import React from 'react';

export interface FilterChipProps {
    label: React.ReactNode;
    isActive: boolean;
    onClick: () => void;
    className?: string;
}

const FilterChip: React.FC<FilterChipProps> = ({ label, isActive, onClick, className = '' }) => (
    <button
        type="button"
        onClick={onClick}
        className={`h-9 px-4 rounded-full border flex flex-row items-center justify-center gap-1.5 text-sm font-medium transition-colors cursor-pointer shrink-0
            ${isActive
                ? 'bg-brand-sage/10 border-brand-sage text-brand-sage'
                : 'bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-800'}
            ${className}`}
    >
        {label}
    </button>
);

export default FilterChip;
